<template>
<div>

	<!-- <div class="new-program-available">
        <a :href="getDevEnvironment ? 'https://kiosk.test:9001/kiosk/' : '/kiosk'">The new Customer Kiosk is now available!  Try it here...</a>
    </div> -->

	<div class="main detail-view filters-closed" id="detail-4473-clean" style="top: -2em;">
		<div class="customer-page-header">
			<div>
				<img v-if="getClient.logo_src" :src="getClient.logo_src">
				<div v-else>{{ getClient.company_name }}</div>
			</div>
			<h1>Firearms Transaction Record, Form 4473</h1>
		</div>

		<div class="login" v-if="!user.user_name">
			<h2>Manager Login</h2>
			<div class="content">
				<label>Username</label>
				<input type="text" v-model="username" v-focus>
				<label>Password</label>
				<input type="password" v-model="password" @keyup.enter="doLogin">
			</div>
			<div class="controls">
				<div class="button action" @click="doLogin">Log In</div>
				<span class="loading" v-if="loading"><i class="fas fa-spinner fa-spin"></i></span>
			</div>
			<div class="message">{{ message }}</div>
		</div>

		<div v-else class="option-content">
			<div class="option-tabs">
				<div :class="['option-tab', showList == 'B' ? 'active' : 'not-active']" @click="getList('B')">
					<h3>Ready for Section B</h3>
				</div>
				<div :class="['option-tab', showList == 'D' ? 'active' : 'not-active' ]" @click="getList('D')">
					<h3>Ready for Section D</h3>
				</div>
				<div :class="['option-tab', showList == 'CORRECTIONS' ? 'active' : 'not-active' ]" @click="getList('CORRECTIONS')">
					<h3>Awaiting Correction</h3>
				</div>
			</div>
			<div v-if="list.length > 0" class="option-list-wrapper">
				<div class="three-columns align-center" style="grid-template-columns: 1fr 1fr 15em;">
					<div><input type="text" placeholder="Filter list..." v-model="filterText"></div>
					<div v-if="showList == 'B'"><b>NOTE:</b> This list includes 4473s with Section A completed<br>but not Sections D or E.</div>
					<div v-if="showList == 'D'"><b>NOTE:</b> This list includes 4473s with Sections B or C completed<br>but not Sections D or E.</div>
					<div v-if="showList == 'CORRECTIONS'"><b>NOTE:</b> This list includes 4473s that have been marked for correction.</div>
					<div class="right">
						<pagination :paging="paging" @updatePage="goToPage"></pagination>
					</div>
				</div>
				<div class="option-list">
					<div class="option-list-item option-list-heading">
						<div>Customer</div>
						<div>Firearm(s)</div>
						<div>Created / ID</div>
					</div>
					<div v-for="(form, index) in filteredList" class="clickable-list-item option-list-item" @click="assignForm(form)">
						<div>
							{{ form.contact_data.full_name || $fullName(form.contact_data) }}
							<div v-if="form.contact_data.address_1">
								{{ form.contact_data.address_1 }}<br>
								{{ form.contact_data.city }}, {{ form.contact_data.state }} {{ form.contact_data.zip_code }}
							</div>
						</div>
						<div v-if="form.form_data.section_a && form.form_data.section_a.firearms_list">
							<div v-for="(firearm, index) in form.form_data.section_a.firearms_list" style="margin: 0 0 0.5em 0;">
								{{ firearm.manufacturer }} {{ firearm.model }} {{ firearm.caliber }}<br>
								<label>Serial Number</label> {{ firearm.serial_number }}
							</div>
						</div>
						<div v-else><b>This form is missing<br>Section A Firearms!</b></div>
						<div>
							{{ form.date_created }}<br>#{{ form.ffl_log_book_form_id }}
						</div>

						<div v-if="showList == 'CORRECTIONS' && form.internal_use_only == 1" style="background-color: #ccc; grid-column: 1 / span 3; font-size: 0.8em; padding: 0.25em;"><i>Awaiting Manager Correction: not available for customer to correct</i></div>

					</div>
				</div>
			</div>

			<div v-else class="option-list-wrapper">
				<div class="empty-list">
					<div v-if="loading"><i class="fa fa-spinner fa-spin" /></div>
					<div v-else>No forms found</div>
				</div>
			</div>

			<div style="margin: 0.5em 0 0 0; text-align: center;">
				<div class="button action" @click="doLogout()">Kiosk Log Out</div>
			</div>
		</div>

		<div v-if="confirmCorrections" class="modal">
			<div class="inner">
				<h2>Correct Customer Section</h2>
				<div class="content">
					<p>Correcting 4473 for customer {{ $fullName(pendingCorrectForm.contact_data) }}...</p>
					<label>Which section?</label>
					<select v-model="correctWhichSection">
						<option value="">Select...</option>
						<option value="B">Section B - Transferee / Buyer Info</option>
						<option value="D">Section D - Transferee / Buyer Recertification</option>
					</select>
				</div>
				<div class="controls">
					<div class="button cancel spaced" @click="confirmCorrections = false">Cancel</div>
					<div :class="['button', correctWhichSection ? 'action' : 'disabled', 'spaced']" @click="assignForm(pendingCorrectForm, true)">Go to Correction</div>
				</div>
			</div>
		</div>

	</div>

</div>
</template>

<script>
import styles from '../detail_4473_clean.scss'
export default {
	name: 'customer-form-4473',
	data() {
		return {
			apiEndpoint: '',
			username: '',
    		password: '',
			message: 'Please have a manager log in.',
    		loading: false,
			user: {
				user_id: '',
				user_name: '',
				user_type_code: '',
				user_initials: ''
			},
			list: [],
			paging: {},
			filterText: '',
			clientHasVariance: false,
			formVersion: 3,
			showList: 'B',
			page: 1,
			correctWhichSection: '',
			pendingCorrectForm: {},
			confirmCorrections: false
		}
	},
	mounted() {
		// global store will have this from get_item_preference in LogBooksModule.vue
		this.clientHasVariance = this.getElectronicStorageVariance
	},
	computed: {
		filteredList() {
			let filtered = this.list.filter(item => {
				return item.contact_data.full_name.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
			})
			return filtered
		},
	},
	methods: {
		doLogin() {
    		if (!this.username || !this.password) return
		    this.message = ''
			this.loading = true
    		this.apiCall({ destination: 'login', data: { user_name: this.username, password: this.password } }).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					this.user = obj.user
					if (obj.user.token) {
						sessionStorage.setItem('fd_token', obj.user.token)
						sessionStorage.setItem('auth', this.user.user_id)
					}
					this.getList('B')
    			} else {
    				this.message = obj.message
    			}
    		})
    	},
    	doLogout() {
			this.username = ''
			this.password = ''
			this.user = {
				user_id: '',
				user_name: '',
				user_type_code: '',
				user_initials: ''
			}
			this.correctWhichSection = ''
			this.list = []
    	},
		getList(which) {
			this.showList = which
			if (this.loading) { return }
			this.loading = true
			this.list = []
			let sectionCompleted = ''
			let internalUseOnly = 0
			switch (which) {
				case 'B':
					sectionCompleted = 'A'
					break;
				case 'D':
					sectionCompleted = 'B,C'
					break;
				case 'CORRECTIONS':
					sectionCompleted = 'B,C,D,E'
					internalUseOnly = true
					break;
			}
			this.apiCall({ destination: 'get_list_ffl_log_book_forms', data: { form_type: "4473", section_completed: sectionCompleted, exlude_cancelled: true, internal_use_only: internalUseOnly, page: this.page } }).then(obj => { // version: this.formVersion, 
				this.loading = false
				if (obj.log_book_forms.length > 0) {
					this.list = obj.log_book_forms
					if (obj.paging) {
						this.paging = obj.paging
					}
				} else {
					this.message = 'No forms found.'
				}
			}).catch(err => {
				console.log(err);
			})
		},
		goToPage(page) {
			this.page = page
			this.getList(this.showList)
		},
		searchForms(which) {
			let searchText = ''
			if (which == 'A') {
				 if (!this.search_section_a_text) {
					 return
				 }
				 this.sectionAForms = []
				 this.searchMessageSectionA = ''
				 searchText = this.search_section_a_text
			}
			if (which == 'C') {
				 if (!this.search_section_c_text) {
					 return
				 }
				 this.sectionCForms = []
				 this.searchMessageSectionC = ''
				 searchText = this.search_section_c_text
			}
			this.apiCall({ destination: 'get_list_ffl_log_book_forms', data: { form_type: "4473", contact_search_term: searchText, section_completed: which, context: 'CUSTOMER' } }).then(obj => {
				if (obj.status == 'error') {
					this.enableSignOnScreen = obj.enable_screen_capture_signature
					if (which == 'A') {
						this.searchMessageSectionA = obj.message
					} else {
						this.searchMessageSectionC = obj.message
					}
				} else if (obj.log_book_forms.length > 0) {
					if (which == 'A') {
						this.sectionAForms = obj.log_book_forms
					} else {
						this.sectionCForms = obj.log_book_forms
					}
				} else {
					if (which == 'A') {
						this.searchMessageSectionA = 'No matching Section A complete forms found.'
					} else {
						this.searchMessageSectionC = 'No matching Section C complete forms found.'
					}
				}
			})
		},
		getCorrectPendingForms() {
			this.gettingCorrectPendingForms = true
			this.correctPendingForms = []
			this.apiCall({ destination: 'get_list_ffl_log_book_forms', data: { form_type: "4473", internal_use_only: true } }).then(obj => {
				this.searchMessageCorrectPending = obj.message
				if (obj.log_book_forms.length > 0) {
					this.correctPendingForms = obj.log_book_forms
				} else {
					this.searchMessageCorrectPending = 'No pending correction forms found.'
				}
			})
		},
		assignForm(assignForm, correctingConfirmed) {
			if (!assignForm.form_data.section_a || !assignForm.form_data.section_a.firearms_list) { return }
			if (this.showList == 'CORRECTIONS' && assignForm.internal_use_only == 1) { return}
			if (assignForm.version > 2) {
				if (correctingConfirmed && !this.correctWhichSection) { return }
				if (assignForm.internal_use_only && !correctingConfirmed) {
					this.pendingCorrectForm = assignForm
					this.confirmCorrections = true
				} else {
					let whichSection = this.correctWhichSection || this.showList
					let path = '?section=' + whichSection
					if (correctingConfirmed) {
						path += '&correcting=1' // &initials=' + this.user.user_initials
					}
					this.$router.push('/logbooks/customer-4473/' + assignForm.ffl_log_book_form_id + path)
				}
			} else {
				this.$router.push('/logbooks/customer-4473-v2?section=' + this.showList + '&id=' + assignForm.ffl_log_book_form_id)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.new-program-available {
    position: fixed;
    top: 40px;
    left: 0;
    width: 100%;
    text-align: center;
    background-color: #4abdac;
    padding: 0.25em;
    a, a:hover { color: white !important; }
}
.login, .form-options {
	padding: 0 0 3em 0;
	h1, h2 {
		margin: 0.25em 0;
		font-weight: 500;
	    font-size: 1.5em;
	    background: none;
	    text-transform: none;
	    padding: 0;
	}
	.get-correct-pending-link {
		cursor: pointer;
	}
	.get-correct-pending-link:hover {
		color: #4abdac;
	}
}
.login {
	margin: 3em auto 4em auto;
	width: 30%;
}
.login label {
	margin-top: 1em;
	display: inline-block;
}

.option-content {
	margin: 1em 0;
    @media all and (min-width: 1180px) {
		margin: 2em;
	}
}
.option-tabs {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	.option-tab {
		border-left: 1px solid #ccc;
		border-right: 1px solid #ccc;
		border-top: 1px solid #ccc;
		border-bottom: 1px solid #ccc;
		padding: 0.25em 0;
		text-align: center;
	}
	.not-active {
		background-color: #f4f4f4;
	}
	.not-active:hover {
		cursor: pointer;
		background-color: #e4e4e4;
	}
	.active {
		border-bottom: 0 none;
	}
}

.option-list-wrapper {
	height: calc(100vh - 20em);
	padding: 1em;
	border-left: 1px solid #ccc;
	border-right: 1px solid #ccc;
	border-bottom: 1px solid #ccc;
}
.option-list {
	height: calc(100vh - 24.66em);
	overflow-y: scroll;
	.option-list-item {
		display: grid;
		grid-template-columns: 1fr 1.25fr 8em;
		grid-column-gap: 1em;
		padding: 0.5em;
	}
	.option-list-heading {
		font-weight: bold;
	}
}
</style>
